/**
 * Log severity levels for the unified PCP logging system.
 *
 * @see .claude/skills/logging/references/logging-strategy.md
 */
export enum LogLevel {
    VERBOSE = 0,
    DEBUG = 1,
    INFO = 2,
    WARNING = 3,
    ERROR = 4,
    CRITICAL = 5,
}
